export const country = {
  comments: 'Provide comments',
};
